import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ArrowLeftIcon } from 'Asset/icon';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ProgressHeader = ({ variant = 'default', currentStep, onBackHandler }) => {
  const { t } = useTranslation('host-attendance', 'host-stream');
  const navigate = useNavigate();

  const STEPS_FORMAT = {
    default: [
      { title: t('capture_photo.selfie.title'), number: 1 },
      { title: t('capture_photo.work_environment.title'), number: 2 },
      { title: t('preview_page.title'), number: 3 },
    ],
    endStream: [
      { title: t('capture_photo.selfie.title'), number: 1 },
      { title: t('capture_photo.work_environment.title'), number: 2 },
      { title: t('host-stream:update_giveaway.title'), number: 3 },
      { title: t('preview_page.title'), number: 4 },
    ],
  };

  const steps = STEPS_FORMAT[variant];

  const onClickArrow = () => {
    if (onBackHandler) onBackHandler();
    else navigate(-1);
  };

  return (
    <Box className={styles['progress-bar__container']}>
      <Box>
        <Box className={styles['back-button__container']}>
          <ArrowLeftIcon onClick={onClickArrow} size="20px" />
        </Box>
        <TextRegular fontSize="var(--font-body1)" color="var(--color-semantic-text)" marginLeft="30px">
          {steps[currentStep]?.title}
        </TextRegular>
      </Box>
      <Box>
        <TextRegular fontSize="var(--font-body1)" color="var(--color-neutral70)">
          {t('capture_photo.step')} {currentStep + 1}/{steps.length}
        </TextRegular>
      </Box>
    </Box>
  );
};

export default ProgressHeader;
